import { Directive, ElementRef, Input, ComponentFactoryResolver, EmbeddedViewRef, ApplicationRef, Injector, OnDestroy } from "@angular/core";
import { TooltipComponent } from "./tooltip.component";

export interface AdComponent {
  data: any;
  show: boolean;
  close: boolean;
  events: any;
}

@Directive({
  selector: "[tooltip]",
  exportAs: "tooltip",
  host: {
    "(focusin)": "show()",
    "(mouseenter)": "show()",
    "(focusout)": "destroyTooltip()",
    "(mouseleave)": "destroyTooltip()",
  },
})
export class TooltipDirective implements OnDestroy {
  @Input("tooltip") tooltipValue!: string;
  @Input("placement") placement!: string;
  @Input("display") display!: boolean;
  @Input("theme") theme!: "dark" | "light";
  @Input("width") width!: string;
  @Input("position") position!: { top: number; left: number };

  showTimeOutId: NodeJS.Timeout;
  componentRef: any;
  elementPosition: any;

  get isTooltipDestroyed() {
    return this.componentRef && this.componentRef.hostView.destroyed;
  }

  constructor(
    private elementRef: ElementRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  ngOnDestroy() {
    this.destroyTooltip();
    if (this.showTimeOutId) clearTimeout(this.showTimeOutId);
  }

  getElementPosition(): void {
    this.elementPosition = this.elementRef.nativeElement.getBoundingClientRect();
  }

  createTooltip(): void {
    this.getElementPosition();
    this.appendComponentToBody();

    this.showTimeOutId = setTimeout(() => {
      this.showTooltipElem();
    }, 0);
  }

  destroyTooltip(): void {
    if (this.isTooltipDestroyed == false) {
      this.hideTooltip();

      if (!this.componentRef || this.isTooltipDestroyed) {
        return;
      }
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
    }
  }

  showTooltipElem(): void {
    (<AdComponent>this.componentRef.instance).show = true;
  }

  hideTooltip(): void {
    if (!this.componentRef || this.isTooltipDestroyed) return;
    (<AdComponent>this.componentRef.instance).show = false;
  }

  appendComponentToBody(): void {
    this.componentRef = this.componentFactoryResolver.resolveComponentFactory(TooltipComponent).create(this.injector);
    (<AdComponent>this.componentRef.instance).data = {
      value: this.tooltipValue,
      element: this.elementRef.nativeElement,
      elementPosition: this.elementPosition,
    };
    this.appRef.attachView(this.componentRef.hostView);
    const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  public show() {
    if (!this.tooltipValue || this.display === false) return;

    if (!this.componentRef || this.isTooltipDestroyed) {
      this.createTooltip();
    } else if (!this.isTooltipDestroyed) {
      this.showTooltipElem();
    }
  }
}
